import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { Banner, BannerVariant } from 'components/Banner';
import { Icon } from 'components/Icon';
import Typography from 'components/Typography/Typography';
import { useSubmitOrder } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { useMerchantState } from 'hooks/context/MerchantState';
import { SCAN_TO_ORDER_ERROR } from 'components/ScanToOrderError.const';

import styles from './ScanToOrderError.module.scss';

type Props = {
  className?: string;
};

export const ScanToOrderError: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { error } = useSubmitOrder();
  const { showRunningOrderState } = useMerchantState();

  return (
    <>
      {showRunningOrderState && error && (
        <>
          <Banner
            variant={BannerVariant.ERROR}
            className={clsx(styles.scanToOrderNote, className)}
            rounded={true}
            aria-live={'assertive'}
            data-testid={SCAN_TO_ORDER_ERROR.banner}
          >
            <div className={styles.errorIcon}>
              <Icon aria-hidden={true} name={'error'} size={32} />
            </div>
            <Typography.Body variant="secondary">
              <Typography.Body variant="secondary" bold>
                {t('cart.cannotSendToKitchen')}
              </Typography.Body>
              {t('cart.somethingWentWrong')}
            </Typography.Body>
          </Banner>
        </>
      )}
    </>
  );
};
